import React from 'react';
import classNames from 'classnames';

import css from './BrandQuickFilters.module.css';

const QUICK_FILTERS = [
  { id: 'all', label: 'All', cat1: null, cat2: null },
  { id: 'sur-ron', label: 'Sur-Ron', cat1: 'emoto', cat2: 'sur-ron', aliases: ['suron', 'sur-ron'] },
  { id: 'talaria', label: 'Talaria', cat1: 'emoto', cat2: 'talaria', aliases: ['talaria'] },
  { id: 'e-ride-pro', label: 'E Ride Pro', cat1: 'emoto', cat2: 'e-ride-pro', aliases: ['erp', 'e-ride-pro'] },
  { id: 'altis', label: 'Altis', cat1: 'emoto', cat2: 'altis', aliases: ['altis'] },
  { id: 'stark', label: 'Stark Future', cat1: 'emoto', cat2: 'stark', aliases: ['sf', 'stark', 'stark-future'] },
  { id: 'rawrr', label: 'Rawrr', cat1: 'emoto', cat2: 'rawrr', aliases: ['rawrr'] },
  { id: '79bike', label: '79Bike', cat1: 'emoto', cat2: '79bike', aliases: ['79bike'] },
  { id: 'segway', label: 'Segway', cat1: 'emoto', cat2: 'segway', aliases: ['segway', 'ninebot'] },
  { id: 'parts', label: 'Parts & Gear', cat1: 'parts', cat2: null, aliases: ['parts', 'part'] },
];

/**
 * BrandQuickFilters
 * Horizontal scrollable quick-filter pills for top e-moto brands and parts.
 */
const BrandQuickFilters = props => {
  const { className, currentCategoryLevel1, currentCategoryLevel2, onSelectBrand, emotoCategoryId } = props;

  const resolvedEmotoCat =
    emotoCategoryId ||
    (currentCategoryLevel1 === 'emotos' ? 'emotos' : 'emoto');

  const isActive = item => {
    if (item.id === 'all') {
      return !currentCategoryLevel1 && !currentCategoryLevel2;
    }
    if (item.cat2) {
      const matchCat1 =
        currentCategoryLevel1 === item.cat1 ||
        currentCategoryLevel1 === 'emoto' ||
        currentCategoryLevel1 === 'emotos';
      const matchCat2 =
        currentCategoryLevel2 === item.cat2 ||
        (item.aliases && item.aliases.includes(currentCategoryLevel2));
      return matchCat1 && matchCat2;
    }
    if (item.cat1) {
      const matchCat1 =
        currentCategoryLevel1 === item.cat1 ||
        (item.aliases && item.aliases.includes(currentCategoryLevel1));
      return matchCat1 && !currentCategoryLevel2;
    }
    return false;
  };

  const handleClick = item => {
    if (isActive(item) && item.id !== 'all') {
      // Toggle off to all
      onSelectBrand(null, null);
    } else {
      const targetCat1 =
        item.cat1 === 'parts'
          ? 'parts'
          : item.cat1
          ? resolvedEmotoCat
          : null;
      onSelectBrand(targetCat1, item.cat2);
    }
  };

  return (
    <div className={classNames(css.root, className)} data-testid="brand-quick-filters">
      <div className={css.pillsContainer}>
        {QUICK_FILTERS.map(item => {
          const active = isActive(item);
          return (
            <button
              key={item.id}
              type="button"
              className={classNames(css.pill, { [css.pillActive]: active })}
              onClick={() => handleClick(item)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BrandQuickFilters;
